import React from 'react';
import { IOldIconProps } from './type';

const BankCardOutline: React.FC<IOldIconProps> = ({
  width = 32,
  height = 32,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 12.75H28.5V22C28.5 23.3807 27.3807 24.5 26 24.5H6C4.61929 24.5 3.5 23.3807 3.5 22V12.75ZM3.5 11.25H28.5V10C28.5 8.61929 27.3807 7.5 26 7.5H6C4.61929 7.5 3.5 8.61929 3.5 10V11.25ZM30 10V11.25V12V12.75V22C30 24.2091 28.2091 26 26 26H6C3.79086 26 2 24.2091 2 22V12.75V12V11.25V10C2 7.79086 3.79086 6 6 6H26C28.2091 6 30 7.79086 30 10ZM6 18.25C5.58579 18.25 5.25 18.5858 5.25 19C5.25 19.4142 5.58579 19.75 6 19.75H12C12.4142 19.75 12.75 19.4142 12.75 19C12.75 18.5858 12.4142 18.25 12 18.25H6Z"
        fill={color}
      />
    </svg>
  );
};

export default BankCardOutline;
